import { render } from "./BaseModal.vue?vue&type=template&id=2517060f&scoped=true&ts=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=2517060f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2517060f"]])

export default __exports__